import React, { memo } from "react";
// import Iconfont from '@gp/components/Iconfont';
import NoData from '@gp/components/NoData';
import LinkJump from '@gp/components/LinkJump';
import { noop, queryJumpable, getNumberOfDotUnit } from "@gp/utils/common";
import './index.scss';
import SvgIcon from "@/pages/home/components/SvgIcon";

interface SimpleCardPropsType {
  style?: React.CSSProperties;
  title: string | JSX.Element;
  url: string;
  count: string | number;
  isNoData: boolean;
  noDataCustomHeight: number,
  titleOnClick?: Function;
  children?: any;
}

const DEFAULT_PROPS: SimpleCardPropsType = {
  style: {},
  title: '',
  url: '',
  count: 0,
  isNoData: true,
  noDataCustomHeight: 200,
  titleOnClick: noop,
  children: null,
};

function SimpleCard(props: SimpleCardPropsType) {

  const {
    style,
    title,
    url,
    count,
    isNoData,
    noDataCustomHeight,
    titleOnClick,
  } = props;

  return (
    <div className="overview-simple-card" style={style}>
      <div className="simple-card-top">
        <div
          className="left-title"
          onClick={(e) => {
            if (!queryJumpable(e)) return;
            titleOnClick?.();
          }}
        >
          <LinkJump className="left-title-text" url={url} stopPropagation={false}>
            <span>{title}</span>
            <SvgIcon type="arrow-right" className="left-title-icon"/>
          </LinkJump>
        </div>
        { count ? <span className="right-count">{getNumberOfDotUnit(count || '0')} items</span> : null}
      </div>
      {isNoData && (<NoData constomStyle={{height: noDataCustomHeight, fontSize: 14}} />)}
      {isNoData || (props?.children || null)}
    </div>
  );
}

SimpleCard.defaultProps = DEFAULT_PROPS;

export default memo(SimpleCard);
